export const USERNAME = "monarchdentistry";
export const PASSWORD = "321321321";
export const PASSCODE = "0000"